module.exports = __webpack_public_path__ + "img/legacy_1.df707eea.jpg";